<script>
    import { navigate }         from "svelte-routing"
    import { setContext }       from 'svelte'
    import _                    from 'lodash'
    import * as api             from '../../shared/api.js'
    import { assignDuration }   from '../../shared/utils.js'
    import { company, domains } from '../../shared/stores.js'
    import AppLoader            from '../../shared/Loader.svelte'
    import SectionTitle         from '../../shared/SectionTitle.svelte'
    import DomainDropdown       from '../../shared/DomainDropdown.svelte'
    import { Inventory }        from '../../shared/inventory.js'
    import Issues               from '../../shared/Issues.svelte'
    import ActivityItem         from './ActivityItem.svelte'

    export let _domain  = false
    export let _company = false

    let active    = -1
    let domain    = null
    let inventory = new Inventory(null)
    let loading   = false
    let error     = false
    let archetype = empty()
    
     
    setContext('activities', {
        setInventory: it => {
            inventory = new Inventory(splitDurationAndUnit(it))
        }
    })

    if(_domain) {
        domain = $domains.find(it => it.domain === _domain)
    }

    function onDomainSelected(selected) {
        const it = selected ? selected.value : null
        if(it) {
            navigate(`/empresa/${$company.id}/atividades/${it.domain}`)
            if(!domain || it.id !== domain.id) {
                domain = it
            }
        } else {
            navigate(`/empresa/${$company.id}/atividades`)
        }
    }

    function splitDurationAndUnit(iv) {
        
        const splitThem = activity => {
            const replacement = assignDuration(activity, activity.period)
            delete replacement.period
            return replacement
        }

        if(iv && iv.activities && iv.activities.length > 0) {
            iv.activities = iv.activities.map(splitThem)
        }
        
        return iv
    }
    
    function loadBuffer(domain) {
        if(!domain) {
            inventory = new Inventory(null)
            return 
        } 

        loading = true
        return api.get(`/inventory/domain/${domain.id}`)
            .then(api.toJsonIf200)
            .then(json => {
                inventory = new Inventory(splitDurationAndUnit(json))
                loading   = false
                error     = false
            })
            .catch(err => {
                loading = false
                error   = err
            })
    }

    function empty() {
        return {
            id        : 0     ,
            purpose   : null  ,
            automatic : false ,
            // period    : null,            
            duration  : null  ,
            unit      : null  ,
            profiles  : []    ,
            basis     : { name: null, variant: {} },
        }
    }

    $: loadBuffer(domain)
    $: activities = inventory.activities()
    $: issues     = inventory.activityIssues()

    // $: inventory.activities().forEach(a => {
    //     console.log(a.purpose, a.profiles)
    // })

</script>
{#if loading || error}
    <AppLoader {error} what="Carregando" inverted={true}/>
{:else}
    <SectionTitle>
        Atividades de Tratamento
    </SectionTitle>
    <DomainDropdown {domain} {onDomainSelected} />
    {#if !domain}
        <div class="ui big message">
            Selecione um domínio
        </div>
    {:else}
        <div class="ui raised segments">
            <div class="ui segment">
                <h2 class="ui header">Atividades</h2>
                <h4 class="ui header">versão: {inventory.latest()}</h4>
            </div>
            {#if issues.length > 0}
                <div class="ui  segment">
                    <Issues {issues}>
                        Problemas com o inventário
                    </Issues>
                </div>
            {/if}
            <ActivityItem 
                bind:active
                activity={archetype} 
                {domain} 
                {inventory} 
                {empty} />
            {#each activities as activity (activity.id)}
                <ActivityItem 
                    bind:active 
                    {activity}
                    {domain} 
                    {inventory} />
            {/each}
        </div>
    {/if}
{/if}
<style>
    h4.ui.header {
        color: #ccc;
        margin: 0 0 2em 0;
    }
</style>
